import { render, staticRenderFns } from "./AboutCardHeadImg.vue?vue&type=template&id=55975f8c&"
import script from "./AboutCardHeadImg.vue?vue&type=script&lang=js&"
export * from "./AboutCardHeadImg.vue?vue&type=script&lang=js&"
import style0 from "./AboutCardHeadImg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports